import SafetyHookResourceModel from '../../generated/types/model/resource/SafetyHookResourceModel';

export default class SafetyHookResourceViewModel extends SafetyHookResourceModel {
  protected transformToDTO() {}
  protected transformFromDTO() {}
}
